import "./Contact.scss";
import emailjs from "@emailjs/browser";
import { useRef, useState } from "react";

function Contact() {
  const form = useRef();
  const [sent, setSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm("service_ausee74", "template_wt0v2bb", form.current, "a-LazszmJy-qoAnZO").then(
      () => {
        console.log("Email sent successfully");
        setSent(true);
      },
      (error) => {
        console.error("Failed to send email:", error);
      }
    );
  };

  return (
    <div className="contact">
      <div className="container">
        <p className="intro">
          Feel free to reach out if you spot a bug, have a question, or just want to share feedback.
          I’ll be happy to help!
        </p>

        {sent ? (
          <p className="sent">✅ Your message has been sent. Thanks!</p>
        ) : (
          <form ref={form} onSubmit={sendEmail}>
            <div className="input">
              <label>Name</label>
              <input type="text" name="user_name" required />
            </div>
            <div className="input">
              <label>Email</label>
              <input type="email" name="user_email" required />
            </div>
            <div className="input">
              <label>Message</label>
              <textarea name="message" required />
            </div>
            <div className="btn-container">
              <button className="btn" type="submit">
                Send message
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

export default Contact;
